var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-wizard-base',{attrs:{"title":_vm.$breakpoint.smAndUp ? _vm.$t('event_wizard.add_title') : null,"progress":_vm.progress},on:{"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }